
      import { loadCSS } from "./ts/utils/misc";
      loadCSS("/css/fa.min.css", true);
      document.getElementById("page404").classList.remove("hidden");
      document.getElementById("page404").classList.remove("hidden");
      document.querySelector("header").classList.add("focus");
      document.title = "404 Not Found | Monkeytype";
    